<template>
  <div class="game">
    <div class="game__shape --shape-1"></div>
    <div class="game__shape --shape-2"></div>
    <div class="game__shape --shape-3"></div>
    <div class="game__shape --shape-4"></div>
    <div class="game__shape --shape-5"></div>
    <div class="game__shape --shape-6"></div>
    <div class="game__shape --shape-7"></div>

    <div class="game__field" :class="{ '--started': isStarted && state === 'greeting', ['--' + state]: true }">
      <div class="game__field-inner">
        <div class="game__field-top">
          <div class="game__field-time">
            {{ timeString }}
          </div>
          <div class="game__field-lte">
            LTE
          </div>
        </div>
        <div class="game__greeting" v-if="state === 'greeting'">
          <div class="game__greeting-item --mobile" :class="{ '--started': isStarted }">
            <span>Cпецпроект</span>
            <h3>Подпишите это быстрее!</h3>
            <p>
              Получив MBA в престижном западном вузе, вы начали активный поиск вакансий на позицию CEO. Внезапно вам
              пришло приглашение стать директором фабрики по производству деревянных треугольных линеек. Ваша задача —
              привести в качестве гендиректора ООО «Деревянные треугольные линейки» к успеху!
            </p>
            <Button @click="start" theme="green">Начать</Button>
            <About></About>
          </div>
          <div class="game__greeting-item --desktop" :class="{ '--started': isStarted }">
            <h3>Правила</h3>
            <p>
              Вы постоянно в разъездах. К счастью, у вас есть Мобильная Электронная Подпись от МегаФона, и вы можете
              подписывать документы удаленно при помощи телефона. Но это нужно делать вовремя, иначе фабрика разорится!
              И, конечно, вас будут отвлекать уведомления других сервисов, будьте внимательны.
            </p>
            <img class="game__greeting-img" src="../assets/megafon-start-2.svg" alt="" />
            <Button @click="play">Играть</Button>
          </div>
        </div>

        <div class="game__level" v-if="state === 'playing'">
          <Pushes :level="currentLevel"></Pushes>
          <Level :level="currentLevel" @win="onWin" @lose="onLose"></Level>
        </div>

        <div class="game__results game__fail" v-if="state === 'lose'">
          <h3>Вы не справились!</h3>
          <p>
            Конечно, МЭП расширяет ваши возможности ведения бизнеса, однако технологии лишь помогают руководителю, а не
            заменяют его
          </p>

          <Button class="button-tracked" theme="white" @click="onLinkClick">Узнать больше о МЭП</Button>
          <Button @click="play">Попробовать еще раз</Button>
          <div class="game__results-socials">
            <div class="game__results-socials-info">Дать сыграть друзьям:</div>
            <div class="game__results-socials-list">
              <span class="game__results-social" @click="$root.$emit('share', 'fb')">
                <img src="../assets/fb-b.svg" alt="" />
              </span>
              <span class="game__results-social" @click="$root.$emit('share', 'vk')">
                <img src="../assets/vk-b.svg" alt="" />
              </span>
              <span class="game__results-social" @click="$root.$emit('share', 'tw')">
                <img src="../assets/tw-b.svg" alt="" />
              </span>
            </div>
          </div>
        </div>

        <div class="game__results  game__win" v-if="state === 'win'">
          <div v-if="currentLevel === 2">
            <h3>Вы отлично начали!</h3>
            <p>
              МЭП — аналог ЭЦП, ничего дополнительно подписывать вам не придётся. Это сильно упрощает работу и жизнь,
              согласитесь!
            </p>
            <Button class="button-tracked" theme="white" @click="onLinkClick">Узнать больше о МЭП</Button>
            <p>
              Продолжим развивать бизнес?
            </p>
            <Button @click="play">Следующий уровень</Button>
          </div>
          <div v-if="currentLevel === 3">
            <h3>Вы совсем освоились!</h3>
            <p>
              Кстати, к МЭП можно подключить ваших юристов и бухгалтеров, чтобы дела шли быстрее.
            </p>
            <Button class="button-tracked" theme="white" @click="onLinkClick">Узнать больше о МЭП</Button>
            <p>
              Продолжим развивать бизнес?
            </p>
            <Button @click="play">Следующий уровень</Button>
          </div>
        </div>

        <div class="game__results  game__totalwin" v-if="state === 'totalwin'">
          <h3>Поздравляем!</h3>
          <p>
            Вам удалось обойти все преграды и подводные камни. Недоброжелатели вынуждены уволиться или смириться с вашим
            назначением — юридическая служба и бухгалтерия за вас горой, потому что вы оперативно подписываете нужные
            документы с помощью МЭП от МегаФона.
          </p>
          <Button class="button-tracked" @click="onLinkClick">Узнать больше о МЭП</Button>
          <div class="game__results-socials">
            <div class="game__results-socials-info">Дать сыграть друзьям:</div>
            <div class="game__results-socials-list">
              <span class="game__results-social" @click="$root.$emit('share', 'fb')">
                <img src="../assets/fb-b.svg" alt="" />
              </span>
              <span class="game__results-social" @click="$root.$emit('share', 'vk')">
                <img src="../assets/vk-b.svg" alt="" />
              </span>
              <span class="game__results-social" @click="$root.$emit('share', 'tw')">
                <img src="../assets/tw-b.svg" alt="" />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Level from './Level'
import Pushes from './Pushes'
import About from './About'
import Button from './Button'

let clock

export default {
  components: { Button, About, Pushes, Level },
  data() {
    return {
      state: 'greeting',
      // state: 'totalwin',
      currentLevel: 1,
      time: Date.now(),
      isStarted: false,
    }
  },
  computed: {
    timeString() {
      const date = new Date(this.time)
      let hours = date.getHours()
      let minutes = date.getMinutes()
      if (hours < 10) {
        hours = '0' + hours
      }
      if (minutes < 10) {
        minutes = '0' + minutes
      }

      return `${hours}:${minutes}`
    },
  },
  mounted() {
    clock = setInterval(() => {
      this.time = Date.now()
    }, 1e3)

    // this.play()
  },
  destroyed() {
    clearInterval(clock)
  },
  methods: {
    onLinkClick() {
      if (this.state === 'win' && this.currentLevel === 2) {
        window.open(
          'https://megafon.ru/corporate/productsandsolutions/products/mobilnaya_elektronnaya_podpis.html?utm_source=vedomosti&utm_medium=game&utm_campaign=vedomosti-mep-2019&utm_content=game1#description'
        )
        window.gtag('event', 'click_to_mep', { event_category: 'button', event_label: 'level1' })
      }
      if (this.state === 'win' && this.currentLevel === 3) {
        window.open(
          'https://megafon.ru/corporate/productsandsolutions/products/mobilnaya_elektronnaya_podpis.html?utm_source=vedomosti&utm_medium=game&utm_campaign=vedomosti-mep-2019&utm_content=game3#description'
        )
        window.gtag('event', 'click_to_mep', { event_category: 'button', event_label: 'level2' })
      }

      if (this.state === 'lose') {
        window.open(
          'https://megafon.ru/corporate/productsandsolutions/products/mobilnaya_elektronnaya_podpis.html?utm_source=vedomosti&utm_medium=game&utm_campaign=vedomosti-mep-2019&utm_content=game3#description'
        )
        window.gtag('event', 'click_to_mep', { event_category: 'button', event_label: 'game_over' })
      }

      if (this.state === 'totalwin') {
        window.open(
          'https://megafon.ru/corporate/productsandsolutions/products/mobilnaya_elektronnaya_podpis.html?utm_source=vedomosti&utm_medium=game&utm_campaign=vedomosti-mep-2019&utm_content=game4#description'
        )
        window.gtag('event', 'click_to_mep', { event_category: 'button', event_label: 'win' })
      }
    },
    play() {
      this.state = 'playing'
      this.$root.$emit('level', this.currentLevel)
    },
    start() {
      this.isStarted = true
    },
    onWin() {
      this.state = 'win'
      if (this.currentLevel === 3) {
        this.state = 'totalwin'
      } else {
        this.currentLevel++
      }
    },
    onLose() {
      this.state = 'lose'
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.game {
  font-size: 24px;
  width: 100%;
  height: 100vh;

  &__shape {
    display: none;

    @media (min-width: 768px) and (min-height: 1024px), (min-height: 768px) and (min-width: 1024px) {
      display: block;
    }

    position: absolute;
    width: 115px;
    height: 103px;
    background: url(../assets/shape.svg) no-repeat center center;
    top: 275px;
    left: 30px;
    &.--shape-1 {
      background-image: url(../assets/shape-2.svg);
    }
    &.--shape-2 {
      left: auto;
      right: 30px;
      top: 555px;
    }
    &.--shape-3 {
      bottom: 100px;
      top: auto;
    }

    &.--shape-3,
    &.--shape-4,
    &.--shape-5,
    &.--shape-6,
    &.--shape-7 {
      display: none;
      @media (min-width: 1280px) and (min-height: 800px) {
        display: block;
      }
    }

    @media (min-width: 1024px) and (min-height: 768px) {
      display: none;
      &.--shape-1 {
        left: 30px;
        bottom: auto;
        top: 545px;
        right: auto;
        display: block;
      }
      &.--shape-2 {
        left: 216px;
        bottom: auto;
        top: 555px;
        right: auto;
        display: block;
        background: url(../assets/megafon-start-2.svg) no-repeat center center;
        width: 241px;
        height: 74px;
      }
    }

    @media (min-width: 1280px) and (min-height: 800px) {
      &.--shape-1 {
        left: 30px;
        top: (545 / 800 * 100%);
      }
      &.--shape-2 {
        left: (216 / 1280 * 100%);
        top: (555 / 800 * 100%);
      }
      &.--shape-3 {
        top: (105 / 800 * 100%);
        left: (530 / 1280 * 100%);
        right: auto;
        bottom: auto;
        background-image: url(../assets/shape-2.svg);
      }

      &.--shape-4 {
        top: (210 / 800 * 100%);
        left: (670 / 1280 * 100%);
        right: auto;
        bottom: auto;
        background-image: url(../assets/shape.svg);
      }
      &.--shape-5 {
        top: (320 / 800 * 100%);
        left: (530 / 1280 * 100%);
        right: auto;
        bottom: auto;
        background-image: url(../assets/shape-2.svg);
      }
      &.--shape-6 {
        top: (45 / 800 * 100%);
        left: (660 / 1280 * 100%);
        right: auto;
        bottom: auto;
        width: 145px;
        height: 90px;
        background-image: url(../assets/sad.svg);
      }
      &.--shape-7 {
        top: (450 / 800 * 100%);
        left: (445 / 1280 * 100%);
        right: auto;
        bottom: auto;
        width: 352px;
        height: 242px;
        background-image: url(../assets/funnyguy.svg);
      }
    }
  }

  &__field {
    /*max-height: 100vh;*/
    max-width: 100vw;
    width: 100vw;
    height: calc(100vh - 39px);
    position: absolute;
    top: 39px;
    background: #fbede5;
    will-change: auto;
    transition: left 0.3s ease-in-out, top 0.3s ease-in-out, transform 0.3s ease-in-out;

    &.--started {
      background: #04b358;
    }

    @media (min-width: 768px) and (min-height: 1024px), (min-height: 768px) and (min-width: 1024px) {
      width: 310px;
      height: 670px;
      top: 292px;
      left: 50%;
      transform: translateX(-50%);
      background: #04b358;
      &.--greeting {
        .game__field-inner {
          background: #04b358;
        }
        .game__field-top {
          color: #fff;
        }
        .game__field-lte {
          background-image: url(../assets/signal-w.svg);
        }
      }
    }

    @media (min-width: 1024px) and (min-height: 768px) {
      top: 50%;
      transform: translateX(30%) translateY(-50%);
    }

    @media (min-width: 1280px) and (min-height: 800px) {
      top: 50%;
      transform: translateY(-50%);
      left: 70%;
    }

    &.--lose {
      background: #eb5a40;
      .game__field-inner {
        background: #eb5a40;
      }

      .game__field-top {
        color: #fff;
      }
      .game__field-lte {
        background-image: url(../assets/signal-w.svg);
      }
    }

    &.--totalwin,
    &.--win {
      background: #00b956;

      .game__field-inner {
        background: #00b956;
      }

      .game__field-top {
        color: #fff;
      }
      .game__field-lte {
        background-image: url(../assets/signal-w.svg);
      }
    }

    &-top {
      display: none;
      color: #887770;
      position: absolute;
      height: 25px;
      font-size: 14px;
      justify-content: space-between;
      width: 100%;
      top: 0;
      left: 0;
      @media (min-width: 768px) and (min-height: 1024px), (min-height: 768px) and (min-width: 1024px) {
        display: flex;
      }
    }

    &-time {
      padding: 10px 0 0 20px;
      line-height: 16px;
    }

    &-lte {
      padding: 10px 14px 0 23px;
      line-height: 14px;
      font-size: 14px;
      background: url(../assets/signal.svg) no-repeat left bottom 3px;
    }

    &-inner {
      position: relative;
      height: 100%;
      z-index: 2;
      padding: 0 0 0;
      max-width: 320px;
      margin: 0 auto;

      @media (min-width: 768px) and (min-height: 1024px), (min-height: 768px) and (min-width: 1024px) {
        background: #e5cfc4;
        border-radius: 28px;
        padding-top: 30px;
      }

      &::after {
        display: none;
        content: '';
        position: absolute;
        height: 27px;
        border-bottom-left-radius: 12px;
        border-bottom-right-radius: 12px;
        width: 170px;
        background: #fff;
        top: -1px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 2;

        @media (min-width: 768px) and (min-height: 1024px), (min-height: 768px) and (min-width: 1024px) {
          display: block;
        }
      }
    }

    &::after {
      @media (min-width: 768px) and (min-height: 1024px), (min-height: 768px) and (min-width: 1024px) {
        display: block;
      }
      display: none;
      background: url(../assets/phone.svg) no-repeat left top;
      background-size: 100% auto;
      content: '';
      position: absolute;
      width: 418px;
      height: 770px;
      top: -51px;
      left: -54px;
      z-index: -1;
    }
  }

  &__level {
    width: 100%;
    max-width: 320px;
    height: inherit;
    overflow-y: hidden;
    position: relative;
  }

  &__greeting {
    position: relative;
    line-height: 0;
    overflow-y: auto;
    height: 100%;

    &-img {
      margin: 40px auto;
      display: block;
      width: 240px;

      @media (min-width: 768px) and (min-height: 1024px), (min-height: 768px) and (min-width: 1024px) {
        display: none;
      }
    }

    &-item {
      padding: 0 15px;
      height: 100%;

      > p {
        font-size: 16px;
        line-height: 22px;
        padding: 0;
        margin: 20px 0 30px;
      }

      &.--mobile {
        display: block;
        padding-top: 81px;

        &::after {
          content: '';
          right: 15px;
          top: 30px;
          position: absolute;
          width: 140px;
          height: 142px;
          background: url(../assets/megafon-start.svg) no-repeat 0 0;
        }

        &.--started {
          display: none;
        }

        @media (min-width: 768px) and (min-height: 1024px), (min-height: 768px) and (min-width: 1024px) {
          display: none;
        }
      }

      &.--desktop {
        display: none;
        padding-top: 20px;
        color: #fff;

        > p {
          font-size: 16px;
          line-height: 26px;
        }

        &.--started {
          display: block;
        }

        @media (min-width: 768px) and (min-height: 1024px), (min-height: 768px) and (min-width: 1024px) {
          display: block;
          padding-top: 210px;
          background-image: url(../assets/megafon-rules.svg);
          background-position: center 25px;
          background-repeat: no-repeat;
          background-size: 165px 167px;

          > p {
            line-height: 22px;
          }
        }
      }
    }

    span {
      font-size: 14px;
      height: 14px;
      color: rgba(0, 0, 0, 0.5);

      margin-bottom: 15px;
      display: block;
    }

    h3 {
      padding: 0;
      margin: 0;
      font-size: 24px;
      line-height: 26px;
      font-weight: bold;
      width: 170px;
    }

    .button {
      margin: 0 0 20px 0;
    }

    @media (min-width: 768px) and (min-height: 1024px), (min-height: 768px) and (min-width: 1024px) {
      .about {
        display: none;
      }
    }
  }

  &__results {
    font-size: 16px;
    line-height: 20px;
    overflow-y: auto;
    height: 100%;
    position: relative;

    &-socials {
      margin-top: 50px;
      font-size: 16px;
      line-height: 20px;
      &-list {
        margin-top: 15px;
        display: flex;
        justify-content: space-between;
      }
      margin-bottom: 10px;
    }

    &-social {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      background: #fff;
      display: block;
      text-align: center;
      line-height: 50px;
      cursor: pointer;
      img {
        vertical-align: middle;
      }
    }
  }

  &__fail {
    color: #fff;
    padding: 220px 30px 0;

    &::after {
      position: absolute;
      content: '';
      width: 100%;
      left: 0;
      top: 0;
      height: 220px;
      background: url(../assets/loser.svg) no-repeat center top 20px;
    }

    h3 {
      font-size: 26px;
      font-weight: bold;
      line-height: 30px;
      margin: 0 0 0;
    }

    p {
      margin: 20px 0;
    }

    .button {
      margin-bottom: 20px;
    }

    .button.--violet {
      margin-bottom: -30px;
    }
  }

  &__win {
    color: #fff;
    padding: 200px 20px 0;
    &::after {
      position: absolute;
      content: '';
      width: 100%;
      left: 0;
      top: 0;
      height: 200px;
      background: url(../assets/total-win.svg) no-repeat center top 20px;
      background-size: 173px auto;
    }

    h3 {
      font-size: 24px;
      font-weight: bold;
      line-height: 26px;
      margin: 0;
    }

    p {
      margin: 20px 0;
      font-size: 16px;
      line-height: 20px;
    }
  }

  &__totalwin {
    color: #fff;
    padding: 180px 20px 0;

    &::after {
      position: absolute;
      content: '';
      width: 100%;
      left: 0;
      top: 0;
      height: 180px;
      background: url(../assets/total-win.svg) no-repeat center top 20px;
      background-size: auto 145px;
    }

    h3 {
      font-size: 26px;
      font-weight: bold;
      line-height: 25px;
      margin: 0 0 20px;
    }

    p {
      margin: 0 0 30px;
      font-size: 16px;
      line-height: 20px;
    }

    .button {
      margin: 0 0 0;
    }
  }
}
.app.--level {
  @media (min-width: 768px) and (min-height: 1024px), (min-height: 768px) and (min-width: 1024px) {
    .about {
      background: transparent;
      max-width: 100%;

      p.--active {
        max-height: 40px;
      }
    }

    .game {
      &__shape {
        display: none;
      }

      &__field {
        top: 50%;
        transform: translateY(-50%) translateX(-50%);
      }
    }
  }
  @media (min-width: 1024px) and (min-height: 768px) {
    .game {
      &__field {
        top: 50%;
        left: 50%;
        transform: translateY(-50%) translateX(-50%);
      }
    }
  }
}
</style>
